// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"787":"plotly","836":"blockmap"}[chunkId] + "." + {"787":"01837fa5","836":"60b4374c"}[chunkId] + ".js";
};